import axios from '@axios'
import JwtService from './jwtService'

// export jwt helper class with axios
export default new JwtService(axios)
